import config from 'constants/config'
import { Experiments } from 'constants/experiments'
import { getMapSearchMarkerCap, getMapSearchPageSize } from 'constants/searchHelpers'
import useExperiment from 'hooks/Experiments/useExperiment'
import { useMemo } from 'react'

/**
 * Map search paging for the geographic diversity experiment.
 *
 * `geoDiversityEnabled` is true only for non-control buckets. List page size is always
 * pinLimit (20); treatment enables map-offer streaming + decoupled pin ordering via rollout.
 */
export default function useMapSearchPaging() {
  const { isAnyVariant: geoDiversityEnabled } = useExperiment(
    Experiments.searchMapGeographicDiversity,
    { canActivate: true },
  )

  return useMemo(() => {
    const pageSize = getMapSearchPageSize(config.search.mapView)

    return {
      geoDiversityEnabled,
      pageSize,
      markerCap: getMapSearchMarkerCap(pageSize, config.search.mapView, geoDiversityEnabled),
    }
  }, [geoDiversityEnabled])
}
